export default __webpack_public_path__ + "static/logo-ae8aaa910c736f2b6d1f44ca10c4349b.png";